export default "__VITE_ASSET__DJRebN0U__"